export const API_ERROR_RESET = 'API_ERROR_RESET'
export const API_NOT_FOUND = 'API_NOT_FOUND'
export const API_SERVER_ERROR = 'SERVER_ERROR'
